var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: _vm.color,
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        },
        [
          _c("line", { attrs: { x1: "4", y1: "6", x2: "11", y2: "6" } }),
          _c("line", { attrs: { x1: "17", y1: "6", x2: "20", y2: "6" } }),
          _c("circle", {
            attrs: { cx: "14", cy: "6", r: "2.5", fill: "none" }
          }),
          _c("line", { attrs: { x1: "4", y1: "12", x2: "5", y2: "12" } }),
          _c("line", { attrs: { x1: "11", y1: "12", x2: "20", y2: "12" } }),
          _c("circle", {
            attrs: { cx: "8", cy: "12", r: "2.5", fill: "none" }
          }),
          _c("line", { attrs: { x1: "4", y1: "18", x2: "14", y2: "18" } }),
          _c("line", { attrs: { x1: "20", y1: "18", x2: "20", y2: "18" } }),
          _c("circle", {
            attrs: { cx: "17", cy: "18", r: "2.5", fill: "none" }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }